import { RatingPercent } from './constants';

export const isValidRatingPercentValue = (ratingPercent: unknown): ratingPercent is RatingPercent =>
  ratingPercent === 100 || ratingPercent === 0 || ratingPercent === null;
